import React from "react";
import { useForm } from "react-hook-form";
import styles from "./RegisterTenants.module.scss";

interface RegisterTenantsProps {
  handleShowModal: () => void;
  getRegistered: (data: {
    tenantName: string;
    tenantEmail: string;
    orgName: string;
  }) => Promise<void>;
  placeholder?: string;
}

interface FormValues {
  orgName: string;
  tenantName: string;
  tenantEmail: string;
}

const RegisterTenants: React.FC<RegisterTenantsProps> = ({
  handleShowModal,
  getRegistered,
  placeholder = "Enter tenant Name",
}) => {
  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
    reset,
  } = useForm<FormValues>({
    defaultValues: {
      orgName: "",
      tenantName: "",
      tenantEmail: "",
    },
  });

  const onSubmit = async (data: FormValues) => {
    try {
      await getRegistered({
        orgName: data.orgName,
        tenantName: data.tenantName,
        tenantEmail: data.tenantEmail,
      });
      reset();
      handleShowModal();
    } catch (error) {
      console.error("Registration error:", error);
      // optionally you can surface error to UI
    }
  };

  return (
    <div className={`${styles.register}`}>
      <h2>Register Tenants</h2>

      <form onSubmit={handleSubmit(onSubmit)}>
        <div className={`${styles.register__input}`}>
          <label>Organization Name</label>
          <input
            type="text"
            {...register("orgName", {
              required: "Organization name is required",
              minLength: { value: 2, message: "Too short" },
            })}
            placeholder="Enter Organization Name"
          />
          {errors.orgName && (
            <span className={`${styles.error}`}>
              {errors.orgName.message}
            </span>
          )}
        </div>

        <div className={`${styles.register__input}`}>
          <label>Tenant Name</label>
          <input
            type="text"
            {...register("tenantName", {
              required: "Tenant name is required",
              minLength: { value: 2, message: "Too short" },
            })}
            placeholder={placeholder}
          />
          {errors.tenantName && (
            <span className={`${styles.error}`}>
              {errors.tenantName.message}
            </span>
          )}
        </div>

        <div className={`${styles.register__input}`}>
          <label>Tenant Email</label>
          <input
            type="text"
            {...register("tenantEmail", {
              required: "Email is required",
              pattern: {
                value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                message: "Invalid email address",
              },
            })}
            placeholder="Enter tenant Email"
          />
          {errors.tenantEmail && (
            <span className={`${styles.error}`}>
              {errors.tenantEmail.message}
            </span>
          )}
        </div>

        <div className={`flex-wrap justify-end ${styles.register__button}`}>
          <button
            className="button sm outline"
            type="button"
            onClick={() => {
              reset();
              handleShowModal();
            }}
            disabled={isSubmitting}
          >
            Cancel
          </button>
          <button
            className="button sm"
            type="submit"
            disabled={isSubmitting}
          >
            {isSubmitting ? "Registering..." : "Register"}
          </button>
        </div>
      </form>
    </div>
  );
};

export default RegisterTenants;
